import { icon_arrow_right } from '@gn-audio/icons';
import { getTitle } from '@gn-audio/jss-core';

import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { MajorLink } from '../megaMenuTypes';

export const MobileMajorSublink = ({
  sublink,
  isLast,
  handleNavigation,
}: {
  sublink: MajorLink;
  isLast: boolean;
  handleNavigation: (link: MajorLink) => void;
}) => {
  const linkField = sublink.Link;
  const title = getTitle(sublink);

  if (!linkField || !title) {
    return null;
  }
  return (
    <li
      tabIndex={0}
      role="link"
      onClick={() => handleNavigation(sublink)}
      className="flex cursor-pointer flex-col"
    >
      <span className="mb-2.5 flex h-full w-full items-center justify-between pt-2.5">
        <span>{title}</span>
        <JabraIcon className="h-4" Icon={icon_arrow_right} />
      </span>
      {!isLast && <hr className="border-b-1 border-slate-tint80" />}
    </li>
  );
};
